import { Point } from '@bpd-library/utilities';
import { Dimensions } from '@features/virtual-tour/types';

import { HouseSelectorPolygon } from './types';

export const convertPercentageGeometryToPixels = (
    { width, height }: Dimensions,
    objects: HouseSelectorPolygon[],
) => {
    const updatePolygonPoints = (object: HouseSelectorPolygon) => {
        if (!object.polygon) return;
        if (!object.polygonPx) object.polygonPx = [];

        const percentageToPixels = ({ x, y }: Point, index: number) => {
            const xPx = Math.floor(width * x!);
            const yPx = Math.floor(height * y!);

            if (object.polygonPx?.[index]) {
                object.polygonPx[index].x = xPx;
                object.polygonPx[index].y = yPx;
            } else {
                object.polygonPx?.push({ x: xPx, y: yPx });
            }
        };

        object.polygon?.forEach(percentageToPixels);
    };

    objects.forEach(updatePolygonPoints);
};
